import { FunctionComponent } from "react";

import { Icon, IconProps } from "./icon";

export const TwitchColor: FunctionComponent<IconProps> = ({ className }) => {
    return (
        <Icon className={className}>
            <rect x="6.6" y="4.2" fill="#5F4495" width="1.4" height="4.2" />
            <path fill="#5F4495" d="M1.4,0L0.4,2.7V14h3.8v2h2.1l2-2h3.1l4.2-4.2V0H1.4z M11.8,11.5H8l-2,2v-2H2.7v-10h11.5v7.6h0L11.8,11.5z" />
            <rect x="10.4" y="4.2" fill="#5F4495" width="1.4" height="4.2" />
        </Icon>
    );
};
